import { Text } from '@billda/design-system';

interface InfoRowProps {
  label: string;
  testId: string;
  children: React.ReactNode;
  multiline?: boolean;
}

export function InfoRow({ label, testId, children, multiline }: InfoRowProps) {
  if (multiline) {
    return (
      <div className="mb-3">
        <Text variant="body2" color="secondary" className="mb-1">
          {label}
        </Text>
        <Text as="div" variant="body2" data-testid={testId}>
          {children}
        </Text>
      </div>
    );
  }

  return (
    <div className="mb-3 flex items-start justify-between gap-4">
      <Text variant="body2" color="secondary" className="shrink-0">
        {label}
      </Text>
      <Text
        as="div"
        variant="body2"
        data-testid={testId}
        className="text-right"
      >
        {children}
      </Text>
    </div>
  );
}
